

const addPopupModal = () => {
  const modalContainer = document.createElement("div");
  modalContainer.setAttribute("id", "modal-container");
  modalContainer.setAttribute("style", "display:none");

  const modalContent = document.createElement("div");
  modalContent.setAttribute("id", "modal-content");
  modalContainer.append(modalContent);

  const modalContentSubtitle = document.createElement("div");
  modalContentSubtitle.setAttribute("id", "modal-subtitle");
  modalContent.append(modalContentSubtitle);

  const modalContentTitle = document.createElement("h2");
  modalContentTitle.setAttribute("id", "modal-title");
  modalContent.append(modalContentTitle);

  const modalContentDescription = document.createElement("p");
  modalContentDescription.setAttribute("id", "modal-desc");
  modalContent.append(modalContentDescription);

  const modalContentCta = document.createElement("a");
  modalContentCta.setAttribute("id", "modal-cta");
  modalContentCta.setAttribute("href", "#");
  modalContentCta.setAttribute("target", "_parent");
  modalContent.append(modalContentCta);
  //
  if(!document.querySelector("#modal-container")) document.querySelector("body")?.prepend(modalContainer);
}

module.exports = addPopupModal;